export function formatUpdatedAt(value?: string, now = Date.now()): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const time = new Intl.DateTimeFormat('sv-SE', { hour: '2-digit', minute: '2-digit' }).format(date);
  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);
  const startOfDate = new Date(date);
  startOfDate.setHours(0, 0, 0, 0);
  const dayDiff = Math.round((startOfToday.getTime() - startOfDate.getTime()) / 86400000);
  if (dayDiff === 0) return `Uppdaterad i dag ${time}`;
  if (dayDiff === 1) return `Uppdaterad i går ${time}`;
  return `Uppdaterad ${new Intl.DateTimeFormat('sv-SE', { day: 'numeric', month: 'short' }).format(date)} ${time}`;
}
